var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgConciergeBackground = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 1832,
    viewBox: "0 0 293 1832",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_224)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.974,
    d: "M91.1386 1192.47C91.1386 1192.47 283.528 1090.14 87.9873 691.474C68.752 652.252 53.6285 617.551 41.9957 586.564C-35.0305 380.179 57.7654 347.887 133.608 242.894C242.772 91.7487 134.963 -64.9782 -177.824 -183.747",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9481,
    d: "M98.1201 1202.07C98.1201 1202.07 290.519 1096.72 96.2749 698.127C77.1369 658.783 61.8578 623.793 49.872 592.366C-27.9016 386.153 64.2243 350.838 140.164 245.116C249.567 92.7672 148.267 -63.6546 -167.488 -184.645",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9221,
    d: "M105.102 1211.67C105.102 1211.67 297.528 1103.3 104.581 704.771C85.5218 665.314 70.0329 630.064 57.7665 598.159C-21.3173 392.329 70.6916 353.762 146.73 247.356C256.363 93.8321 161.58 -62.3126 -157.16 -185.515",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8961,
    d: "M112.083 1221.27C112.083 1221.27 304.547 1109.89 112.887 711.415C93.9072 671.845 78.2446 636.316 65.6613 603.952C-14.306 398.343 77.1593 356.686 153.286 249.578C263.158 94.8505 174.876 -60.9613 -146.823 -186.413",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8701,
    d: "M119.065 1230.87C119.065 1230.87 311.556 1116.46 121.175 718.069C102.275 678.386 86.4563 642.567 73.5382 609.755C-7.33075 404.378 83.6189 359.637 159.843 251.8C269.936 95.879 188.18 -59.6378 -136.505 -187.301",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8442,
    d: "M126.047 1240.47C126.047 1240.47 318.566 1123.04 129.491 724.731C110.66 684.917 94.6958 648.827 81.4428 615.566C-0.281923 410.419 90.0963 362.579 166.409 254.04C276.751 96.934 201.476 -58.2861 -126.158 -188.181",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8182,
    d: "M133.01 1250.09C133.01 1250.09 325.556 1129.63 137.778 731.385C119.026 691.458 102.907 655.079 89.309 621.351C6.71882 416.416 96.5174 365.505 172.955 256.244C283.517 97.9448 214.77 -56.9802 -115.832 -189.097",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7922,
    d: "M139.992 1259.69C139.992 1259.69 332.575 1136.22 146.066 738.039C127.394 697.999 111.118 661.331 97.1858 627.153C13.7579 422.439 102.967 368.438 179.503 258.494C290.314 99.0095 228.075 -55.6105 -105.522 -189.957",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7662,
    d: "M146.974 1269.29C146.974 1269.29 339.584 1142.79 154.371 744.683C135.778 704.53 119.347 667.573 105.08 632.946C20.8326 428.443 109.444 371.38 186.059 260.716C297.109 100.028 241.36 -54.2769 -95.1862 -190.855",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7403,
    d: "M153.956 1278.89C153.956 1278.89 346.593 1149.37 162.678 751.327C144.164 711.062 127.577 673.815 112.975 638.739C27.8982 434.428 115.912 374.304 192.634 262.928C303.914 101.065 254.683 -52.963 -84.8398 -191.735",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7143,
    d: "M160.937 1288.49C160.937 1288.49 353.584 1155.95 170.965 757.981C152.531 717.603 135.798 680.085 120.851 644.542C34.9729 440.432 122.361 377.237 199.172 265.16C310.691 102.094 267.968 -51.6293 -74.5219 -192.623",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6883,
    d: "M167.918 1298.1C167.918 1298.1 360.593 1162.53 179.271 764.625C160.906 724.116 144.027 686.327 128.728 650.345C42.0658 446.426 128.82 380.189 205.72 267.41C317.459 103.151 281.255 -50.2497 -64.1941 -193.492",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6623,
    d: "M174.882 1307.71C174.882 1307.71 367.593 1169.13 187.558 771.279C169.273 730.657 152.257 692.569 136.604 656.147C49.1586 452.42 135.269 383.123 212.276 269.632C324.264 104.187 294.559 -48.9258 -53.876 -194.38",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6364,
    d: "M181.863 1317.31C181.863 1317.31 374.602 1175.71 195.856 777.951C177.649 737.216 160.478 698.839 144.49 661.968C56.2613 458.432 141.728 386.075 218.824 271.883C331.032 105.244 307.836 -47.5639 -43.5483 -195.25",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6104,
    d: "M188.845 1326.91C188.845 1326.91 381.611 1182.28 204.162 784.595C186.052 743.737 168.707 705.081 152.375 667.743C63.399 464.379 148.196 388.999 225.389 274.077C337.846 106.254 321.148 -46.2678 -33.2215 -196.166",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5844,
    d: "M195.827 1336.51C195.827 1336.51 388.62 1188.86 212.467 791.239C194.437 750.269 176.964 711.331 160.27 673.536C70.5377 470.371 154.663 391.923 231.955 276.317C344.65 107.291 334.461 -44.9257 -22.8759 -197.045",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5584,
    d: "M202.808 1346.11C202.808 1346.11 395.638 1195.45 220.754 797.893C202.804 756.81 185.193 717.573 168.146 679.339C77.6662 476.345 161.112 394.856 238.492 278.549C351.418 108.348 347.737 -43.5641 -12.5584 -197.933",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5325,
    d: "M209.789 1355.72C209.789 1355.72 402.647 1202.03 229.06 804.538C211.188 763.341 193.441 723.806 176.04 685.132C84.8314 482.301 167.589 397.799 245.066 280.762C358.232 109.357 361.059 -42.2497 -2.22218 -198.83",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5065,
    d: "M216.752 1365.33C216.752 1365.33 409.638 1208.61 237.348 811.191C219.545 769.864 201.652 730.057 183.916 690.935C91.9784 488.265 174.039 400.732 251.604 282.994C365 110.414 374.344 -40.9159 8.10535 -199.7",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4805,
    d: "M223.734 1374.93C223.734 1374.93 416.629 1215.2 245.636 817.846C227.913 776.405 209.881 736.3 191.793 696.738C99.1356 494.248 180.488 403.666 258.143 285.226C371.777 111.443 387.612 -39.5721 18.4058 -200.578",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4545,
    d: "M230.716 1384.53C230.716 1384.53 423.648 1221.79 253.941 824.49C236.298 782.937 218.138 742.55 199.688 702.531C106.319 500.193 186.965 406.608 264.727 287.457C378.6 112.47 400.953 -38.2219 28.7694 -201.467",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4286,
    d: "M237.697 1394.13C237.697 1394.13 430.656 1228.36 262.246 831.134C244.682 789.468 226.403 748.772 207.581 708.324C113.501 506.138 193.432 409.532 271.283 289.679C385.386 113.517 414.238 -36.888 39.105 -202.364",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4026,
    d: "M244.679 1403.73C244.679 1403.73 437.665 1234.94 270.544 837.806C253.059 796.027 234.643 755.032 215.458 714.127C120.667 512.093 199.882 412.466 277.839 291.901C392.181 114.536 427.541 -35.5636 49.4233 -203.252",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3766,
    d: "M251.642 1413.35C251.642 1413.35 444.655 1241.52 278.831 844.46C261.425 802.568 242.871 761.275 223.316 719.94C127.841 518.066 206.313 415.41 284.359 294.143C398.931 115.603 440.808 -34.22 59.7226 -204.13",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3506,
    d: "M258.623 1422.95C258.623 1422.95 451.674 1248.12 287.137 851.104C269.8 809.082 251.147 767.515 231.21 725.733C135.043 524.001 212.79 418.352 290.924 296.384C405.736 116.64 454.113 -32.8498 70.0502 -204.999",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3247,
    d: "M265.604 1432.55C265.604 1432.55 458.683 1254.69 295.424 857.758C278.167 815.622 259.376 773.757 239.087 731.536C142.244 529.936 219.221 421.296 297.481 298.606C412.523 117.687 467.416 -31.5259 80.3861 -205.897",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2987,
    d: "M272.585 1442.15C272.585 1442.15 465.691 1261.27 303.729 864.402C286.551 822.154 267.641 779.98 246.981 737.329C149.472 535.88 225.688 424.22 304.036 300.829C419.317 118.707 480.719 -30.2013 90.7133 -206.766",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2727,
    d: "M279.567 1451.75C279.567 1451.75 472.701 1267.84 312.035 871.047C294.955 828.675 275.888 786.212 254.875 743.122C156.692 541.806 232.166 427.162 310.593 303.051C426.112 119.726 494.004 -28.8675 101.05 -207.663",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2468,
    d: "M286.558 1461.37C286.558 1461.37 479.71 1274.46 320.332 877.719C303.331 835.235 284.155 792.481 262.761 748.943C163.902 547.759 238.624 430.114 317.158 305.292C432.908 120.791 507.326 -27.507 111.395 -208.542",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2208,
    d: "M293.521 1470.99C293.521 1470.99 486.701 1281.05 328.619 884.373C311.697 841.776 292.402 798.713 270.637 754.746C171.132 553.703 245.074 433.048 323.706 307.542C439.695 121.839 520.603 -26.1451 121.704 -209.402",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1948,
    d: "M300.493 1480.57C300.493 1480.57 493.7 1287.61 336.915 890.999C320.062 848.271 300.657 804.918 278.512 760.503C178.349 559.583 251.531 435.955 330.261 309.719C446.48 122.84 533.904 -24.8668 132.038 -210.345",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1688,
    d: "M307.484 1490.19C307.484 1490.19 500.718 1294.2 345.222 897.689C328.448 854.849 308.924 811.186 286.407 766.342C185.606 565.535 257.999 438.925 336.818 311.987C453.276 123.905 547.209 -23.4966 142.357 -211.187",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1429,
    d: "M314.465 1499.79C314.465 1499.79 507.737 1300.79 353.527 904.333C336.833 861.38 317.189 817.409 294.302 772.135C192.843 571.451 264.467 441.849 343.374 314.21C460.081 124.943 560.494 -22.1625 152.693 -212.084",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1169,
    d: "M321.447 1509.39C321.447 1509.39 514.746 1307.37 361.833 910.978C345.218 867.911 325.464 823.65 302.196 777.929C200.098 577.357 270.944 444.791 349.958 316.44C466.885 125.98 573.835 -20.8117 163.057 -212.973",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0909,
    d: "M328.428 1518.99C328.428 1518.99 521.755 1313.94 370.12 917.632C353.584 874.452 333.783 829.843 310.072 783.732C207.671 583.115 277.393 447.725 356.496 318.673C473.662 127.009 587.101 -19.468 173.357 -213.85",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4_224)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.974,
    d: "M91.1386 639.534C91.1386 639.534 283.528 741.863 87.9873 1140.53C68.752 1179.75 53.6285 1214.45 41.9957 1245.44C-35.0305 1451.82 57.7654 1484.11 133.608 1589.11C242.772 1740.25 134.963 1896.98 -177.824 2015.75",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9481,
    d: "M98.1201 629.932C98.1201 629.932 290.519 735.278 96.2749 1133.87C77.1369 1173.22 61.8578 1208.21 49.872 1239.63C-27.9016 1445.85 64.2243 1481.16 140.164 1586.88C249.567 1739.23 148.267 1895.65 -167.488 2016.64",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9221,
    d: "M105.102 620.33C105.102 620.33 297.528 728.703 104.581 1127.23C85.5218 1166.69 70.0329 1201.94 57.7665 1233.84C-21.3173 1439.67 70.6916 1478.24 146.73 1584.64C256.363 1738.17 161.58 1894.31 -157.16 2017.51",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8961,
    d: "M112.083 610.729C112.083 610.729 304.547 722.11 112.887 1120.58C93.9072 1160.15 78.2446 1195.68 65.6613 1228.05C-14.306 1433.66 77.1593 1475.31 153.286 1582.42C263.158 1737.15 174.876 1892.96 -146.823 2018.41",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8701,
    d: "M119.065 601.127C119.065 601.127 311.556 715.535 121.175 1113.93C102.275 1153.61 86.4563 1189.43 73.5382 1222.25C-7.33075 1427.62 83.6189 1472.36 159.843 1580.2C269.936 1736.12 188.18 1891.64 -136.505 2019.3",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8442,
    d: "M126.047 591.525C126.047 591.525 318.566 708.96 129.491 1107.27C110.66 1147.08 94.6958 1183.17 81.4428 1216.43C-0.281923 1421.58 90.0963 1469.42 166.409 1577.96C276.751 1735.07 201.476 1890.29 -126.158 2020.18",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8182,
    d: "M133.01 581.913C133.01 581.913 325.556 702.375 137.778 1100.61C119.026 1140.54 102.907 1176.92 89.309 1210.65C6.71882 1415.58 96.5174 1466.5 172.955 1575.76C283.517 1734.06 214.77 1888.98 -115.832 2021.1",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7922,
    d: "M139.992 572.312C139.992 572.312 332.575 695.782 146.066 1093.96C127.394 1134 111.118 1170.67 97.1858 1204.85C13.7579 1409.56 102.967 1463.56 179.503 1573.51C290.314 1732.99 228.075 1887.61 -105.522 2021.96",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7662,
    d: "M146.974 562.71C146.974 562.71 339.584 689.207 154.371 1087.32C135.778 1127.47 119.347 1164.43 105.08 1199.05C20.8326 1403.56 109.444 1460.62 186.059 1571.28C297.109 1731.97 241.36 1886.28 -95.1862 2022.85",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7403,
    d: "M153.956 553.108C153.956 553.108 346.593 682.632 162.678 1080.67C144.164 1120.94 127.577 1158.19 112.975 1193.26C27.8982 1397.57 115.912 1457.7 192.634 1569.07C303.914 1730.93 254.683 1884.96 -84.8398 2023.73",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7143,
    d: "M160.937 543.506C160.937 543.506 353.584 676.047 170.965 1074.02C152.531 1114.4 135.798 1151.92 120.851 1187.46C34.9729 1391.57 122.361 1454.76 199.172 1566.84C310.691 1729.91 267.968 1883.63 -74.5219 2024.62",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6883,
    d: "M167.918 533.905C167.918 533.905 360.593 669.472 179.271 1067.37C160.906 1107.88 144.027 1145.67 128.728 1181.66C42.0658 1385.57 128.82 1451.81 205.72 1564.59C317.459 1728.85 281.255 1882.25 -64.1941 2025.49",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6623,
    d: "M174.882 524.293C174.882 524.293 367.593 662.869 187.558 1060.72C169.273 1101.34 152.257 1139.43 136.604 1175.85C49.1586 1379.58 135.269 1448.88 212.276 1562.37C324.264 1727.81 294.559 1880.93 -53.876 2026.38",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6364,
    d: "M181.863 514.691C181.863 514.691 374.602 656.294 195.856 1054.05C177.649 1094.78 160.478 1133.16 144.49 1170.03C56.2613 1373.57 141.728 1445.93 218.824 1560.12C331.032 1726.76 307.836 1879.56 -43.5483 2027.25",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6104,
    d: "M188.845 505.089C188.845 505.089 381.611 649.718 204.162 1047.4C186.052 1088.26 168.707 1126.92 152.375 1164.26C63.399 1367.62 148.196 1443 225.389 1557.92C337.846 1725.75 321.148 1878.27 -33.2215 2028.17",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5844,
    d: "M195.827 495.488C195.827 495.488 388.62 643.143 212.467 1040.76C194.437 1081.73 176.964 1120.67 160.27 1158.46C70.5377 1361.63 154.663 1440.08 231.955 1555.68C344.65 1724.71 334.461 1876.93 -22.8759 2029.04",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5584,
    d: "M202.808 485.886C202.808 485.886 395.638 636.55 220.754 1034.11C202.804 1075.19 185.193 1114.43 168.146 1152.66C77.6662 1355.65 161.112 1437.14 238.492 1553.45C351.418 1723.65 347.737 1875.56 -12.5584 2029.93",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5325,
    d: "M209.789 476.284C209.789 476.284 402.647 629.975 229.06 1027.46C211.188 1068.66 193.441 1108.19 176.04 1146.87C84.8314 1349.7 167.589 1434.2 245.066 1551.24C358.232 1722.64 361.059 1874.25 -2.22218 2030.83",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5065,
    d: "M216.752 466.672C216.752 466.672 409.638 623.39 237.348 1020.81C219.545 1062.14 201.652 1101.94 183.916 1141.06C91.9784 1343.74 174.039 1431.27 251.604 1549.01C365 1721.59 374.344 1872.92 8.10535 2031.7",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4805,
    d: "M223.734 457.07C223.734 457.07 416.629 616.805 245.636 1014.15C227.913 1055.59 209.881 1095.7 191.793 1135.26C99.1356 1337.75 180.488 1428.33 258.143 1546.77C371.777 1720.56 387.612 1871.57 18.4058 2032.58",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4545,
    d: "M230.716 447.469C230.716 447.469 423.648 610.212 253.941 1007.51C236.298 1049.06 218.138 1089.45 199.688 1129.47C106.319 1331.81 186.965 1425.39 264.727 1544.54C378.6 1719.53 400.953 1870.22 28.7694 2033.47",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4286,
    d: "M237.697 437.867C237.697 437.867 430.656 603.636 262.246 1000.87C244.682 1042.53 226.403 1083.23 207.581 1123.68C113.501 1325.86 193.432 1422.47 271.283 1542.32C385.386 1718.48 414.238 1868.89 39.105 2034.36",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4026,
    d: "M244.679 428.265C244.679 428.265 437.665 597.061 270.544 994.194C253.059 1035.97 234.643 1076.97 215.458 1117.87C120.667 1319.91 199.882 1419.53 277.839 1540.1C392.181 1717.46 427.541 1867.56 49.4233 2035.25",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3766,
    d: "M251.642 418.653C251.642 418.653 444.655 590.476 278.831 987.54C261.425 1029.43 242.871 1070.73 223.316 1112.06C127.841 1313.93 206.313 1416.59 284.359 1537.86C398.931 1716.4 440.808 1866.22 59.7226 2036.13",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3506,
    d: "M258.623 409.052C258.623 409.052 451.674 583.883 287.137 980.896C269.8 1022.92 251.147 1064.48 231.21 1106.27C135.043 1308 212.79 1413.65 290.924 1535.62C405.736 1715.36 454.113 1864.85 70.0502 2037",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3247,
    d: "M265.604 399.45C265.604 399.45 458.683 577.308 295.424 974.242C278.167 1016.38 259.376 1058.24 239.087 1100.46C142.244 1302.06 219.221 1410.7 297.481 1533.39C412.523 1714.31 467.416 1863.53 80.3861 2037.9",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2987,
    d: "M272.585 389.848C272.585 389.848 465.691 570.732 303.729 967.598C286.551 1009.85 267.641 1052.02 246.981 1094.67C149.472 1296.12 225.688 1407.78 304.036 1531.17C419.317 1713.29 480.719 1862.2 90.7133 2038.77",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2727,
    d: "M279.567 380.246C279.567 380.246 472.701 564.157 312.035 960.953C294.955 1003.32 275.888 1045.79 254.875 1088.88C156.692 1290.19 232.166 1404.84 310.593 1528.95C426.112 1712.27 494.004 1860.87 101.05 2039.66",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2468,
    d: "M286.558 370.626C286.558 370.626 479.71 557.536 320.332 954.281C303.331 996.765 284.155 1039.52 262.761 1083.06C163.902 1284.24 238.624 1401.89 317.158 1526.71C432.908 1711.21 507.326 1859.51 111.395 2040.54",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2208,
    d: "M293.521 361.015C293.521 361.015 486.701 550.951 328.619 947.627C311.697 990.224 292.402 1033.29 270.637 1077.25C171.132 1278.3 245.074 1398.95 323.706 1524.46C439.695 1710.16 520.603 1858.15 121.704 2041.4",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1948,
    d: "M300.493 351.431C300.493 351.431 493.7 544.393 336.915 941.001C320.062 983.729 300.657 1027.08 278.512 1071.5C178.349 1272.42 251.531 1396.05 330.261 1522.28C446.48 1709.16 533.904 1856.87 132.038 2042.35",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1688,
    d: "M307.484 341.811C307.484 341.811 500.718 537.8 345.222 934.311C328.448 977.152 308.924 1020.81 286.407 1065.66C185.606 1266.47 257.999 1393.08 336.818 1520.01C453.276 1708.09 547.209 1855.5 142.357 2043.19",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1429,
    d: "M314.465 332.21C314.465 332.21 507.737 531.207 353.527 927.667C336.833 970.62 317.189 1014.59 294.302 1059.86C192.843 1260.55 264.467 1390.15 343.374 1517.79C460.081 1707.06 560.494 1854.16 152.693 2044.08",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1169,
    d: "M321.447 322.608C321.447 322.608 514.746 524.632 361.833 921.022C345.218 964.089 325.464 1008.35 302.196 1054.07C200.098 1254.64 270.944 1387.21 349.958 1515.56C466.885 1706.02 573.835 1852.81 163.057 2044.97",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0909,
    d: "M328.428 313.006C328.428 313.006 521.755 518.056 370.12 914.368C353.584 957.548 333.783 1002.16 310.072 1048.27C207.671 1248.89 277.393 1384.27 356.496 1513.33C473.662 1704.99 587.101 1851.47 173.357 2045.85",
    stroke: "currentColor",
    strokeOpacity: 0.08,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 293,
    height: 916,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4_224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 293,
    height: 916,
    fill: "none",
    transform: "matrix(1 0 0 -1 0 1832)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgConciergeBackground);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/concierge-background.a0a881bd6944b2743904deefb74c9b79.svg";